import React from 'react';
import {
  CssBaseline, makeStyles, Container,
} from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Form from './Form';
import Display from './Display';
import Header from './Header';
import { ValidacaoContextProvider } from './Context';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

function Validacao() {
  const classes = useStyles();
  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <Helmet>
        <title>Meus Docs - Validação de Documentos</title>
      </Helmet>
      <div className={classes.paper}>
        <ValidacaoContextProvider>
          <Header />
          <Form />
          <Display />
        </ValidacaoContextProvider>
      </div>
    </Container>
  );
}

export default Validacao;
